import {TableColumn} from "../../../interfaces/table/table-column";
import {TableColumnType} from "../../../enums/table-column-type";

export enum PendingUsersTableColumn {
  CpPendingUserId = 'cp_pending_user_id',
  FirstName = 'first_name',
  LastName = 'last_name',
  WorkEmail = 'work_email',
  Phone = 'phone',
}

export const PENDING_USERS_TABLE_COLUMNS: TableColumn[] = [
  {
    columnId: PendingUsersTableColumn.FirstName,
    header: 'First Name',
    type: TableColumnType.Text,
    sortable: true,
  },
  {
    columnId: PendingUsersTableColumn.LastName,
    header: 'Last Name',
    type: TableColumnType.Text,
    sortable: true,
  },
  {
    columnId: PendingUsersTableColumn.WorkEmail,
    header: 'Email',
    type: TableColumnType.Text,
    sortable: true,
  },
  {
    columnId: PendingUsersTableColumn.Phone,
    header: 'Phone',
    type: TableColumnType.Text,
    sortable: true,
  }
];
